import React from 'react';
import { useIncrementalRendering } from '@/hooks';
import { DATETIME } from '@/util/ColumnType';
import { DrilldownCell } from './DrilldownCell';

export const CellRenderer: React.FC<any> = ({ cells, rowIndex }) => {
  const toRender = useIncrementalRendering(cells.length, 10, 100);

  return cells.slice(0, toRender).map((cellData: any, index: number) => {
    const className = `custom ${
      cellData.columnType._type === DATETIME ? ' column-type-DATETIME' : ''
    } position-relative`;
    return (
      <DrilldownCell
        key={`${rowIndex}:${index}:${cellData.columnName}`}
        className={className}
        isResultsOnboardingShown={rowIndex === 0 && index === 1}
        cellData={cellData}
      />
    );
  });
};
